module.exports = __webpack_public_path__ + "static/media/ciclismo.cc3531a4.jpg";